import { Accordion, ActionIcon, Badge, Box, Button, Checkbox, Loader, Paper, Text, Title } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { Buffer } from 'buffer';
import React, { useEffect } from 'react';
import { FaArrowLeft, FaMap, FaPencilAlt, FaTrash } from 'react-icons/fa';
import Table from '../../components/table';
import { formatAddress, getExtenseDatetime, getVehicleTitle, groupBy } from '../../utility/util';
import VehicleHistoryPage from '../../pages/device_history';
import { GET_ALL_VEHICLES } from '../../services/vehicles';

export default function Vehicles({ onGenerate }){
    const [loadingVehicles, setLoadingVehicles] = React.useState<boolean>(false);
    const [loadingGenerate, setLoadingGenerate] = React.useState<boolean>(false);
    const [registersOpen, setRegistersOpen] = React.useState<any>(null);
    const [vehicles, setVehicles] = React.useState<any[]>([]);
    
    const loadVehicles = () => {
        setLoadingVehicles(true)
        GET_ALL_VEHICLES({ children: true })
        .then((res: any[]) => {
            setVehicles(groupBy(res, item => item.company, "_id"));
            setLoadingVehicles(false);
        })
        .catch(err => {
            setLoadingVehicles(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    const generate = () => {
        setLoadingGenerate(true);

        let csvText = [
            [
                "Empresa",
                "Modelo",
                "IMEI",
                "Number",
                "SSID",
                "Host",
                "Created At",
            ],
            ...vehicles.reduce((pv, g) => pv.concat(
                g[1].map(item => [
                    g[0]?.name,
                    item?.model?.title,
                    item?.props?.DEV_ID,
                    item?.props?.CHIP_NO,
                    item?.props?.SSID_CHIP,
                    item?.apn?.host,
                    item?.createdAt,
                ])
            ), []),
        ].map(items => items.map(it => `"${it ?? ""}"`).join(",")).join("\n")
    
        const byteCharacters = Buffer.from(csvText, "utf-8");
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) { byteNumbers[i] = byteCharacters[i]; }
        const byteArray = new Uint8Array(byteNumbers);
    
        const blob = new Blob([byteArray], { type: "application/csv" });
    
        const url = URL.createObjectURL(blob);;
        const a = document.createElement('a');
        a.href = url;
        a.download = `Dispositivos_Satify.csv`;
        a.click();
        URL.revokeObjectURL(url);

        onGenerate && onGenerate();   
        setLoadingGenerate(false);
    }

    useEffect(loadVehicles, []);

    if(registersOpen) return <Box>
        <ActionIcon onClick={() => setRegistersOpen(null)}><FaArrowLeft /></ActionIcon>
        <VehicleHistoryPage title={false} deviceId={registersOpen._id} />
    </Box>
    return <div>
        {/* <Button
            variant='filled'
            color="orange"
            size="sm"
            loading={loadingGenerate}
            onClick={generate}
        >Exportar Dados (CSV)</Button> */}

        {loadingVehicles ? <Loader size="sm" /> : vehicles.length === 0 && <Title order={3} mt="md">Nenhum dispositivo cadastrado</Title>}
        <Paper p="md" shadow='xs' mt="md">
            <Accordion>
                {
                    vehicles.map(g => <Accordion.Item value={g[1][0]?._id}>
                        <Accordion.Control
                            icon={<Badge color="orange">{g[1].length}</Badge>}
                        ><Text size="sm">{g[1][0]?.company?.name}</Text></Accordion.Control>
                        <Accordion.Panel>
                            <Table
                                actions={[
                                    { title: "Registros", onClick: ({ item }) => setRegistersOpen((item?.devices ?? [])[0]?.device) }
                                ]}
                                columns={[
                                    { key: "type", title: "Tipo", style: { minWidth: 100 }, render:  (item) => getVehicleTitle(item.type) },
                                    { key: "text", title: "Veículo", render: (item) => [
                                        item.license_plate,
                                        item.brand,
                                        item.model,
                                        item.year,
                                    ].filter(nn => nn).join(" - ") },
                                    { key: "address", title: "Última Localização", style: { minWidth: 300 }, render: (item) => <Text size="xs">{formatAddress((item.devices ?? [])[0]?.device?.lastHistory?.props)}</Text> },
                                ]}
                                data={g[1]}
                            />
                        </Accordion.Panel>
                    </Accordion.Item>)
                }
            </Accordion>
        </Paper>
    </div>
}